<template lang="">
  <section class="mt-4 mt-lg-5 container-fluid">
    <h4 class="text-secondary px-3 px-lg-0">Pago seguro</h4>
    <div class="d-flex gap-2 align-items-stretch mt-2 flex-wrap">
      <div v-for="(benefit, index) in benefits" :key="index" class="flex-fill">
        <div class="card">
          <div
            class="card-body p-2 p-lg-3 d-flex align-items-center gap-2 text-wrap"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <small class="text-primary">{{ benefit.text }}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex gap-2 align-items-stretch mt-2 flex-wrap">
      <div
        v-for="item in paymentMethods"
        v-show="item.show"
        :key="item.id"
        class="flex-fill text-center p-1 rounded shadow-sm"
        :class="{ 'payment-method-desktop-only': !item.mobile }"
      >
        <router-link :to="'/formas-de-pago'">
          <lazy-image
            :src="item.image"
            :alt="item.name"
            width="72"
            height="48"
          />
        </router-link>
      </div>
      <router-link
        :to="'/formas-de-pago'"
        class="btn btn-light flex-fill d-flex align-items-center"
      >
        Ver todas las formas de pago
        <i class="bi bi-plus-circle-fill text-info ms-1 fs-6"></i>
      </router-link>
    </div>
  </section>
</template>

<script lang="ts">
import type { PaypmentMethodHome } from "~/interfaces/PaypmentMethodMeta";
import LazyImage from "../utils/LazyImage.vue";

export default {
  components: {
    LazyImage,
  },
  props: {
    showMaster: {
      type: Boolean,
      default: true,
    },
    showMaster2: {
      type: Boolean,
      default: true,
    },
    showVisa: {
      type: Boolean,
      default: true,
    },
    showVisa2: {
      type: Boolean,
      default: true,
    },
    showPaypal: {
      type: Boolean,
      default: true,
    },
    showPaypal2: {
      type: Boolean,
      default: true,
    },
    showRappi: {
      type: Boolean,
      default: true,
    },
    showWalmart: {
      type: Boolean,
      default: true,
    },
    showBenavides: {
      type: Boolean,
      default: true,
    },
    showSams: {
      type: Boolean,
      default: true,
    },
    showSeven: {
      type: Boolean,
      default: true,
    },
    hideInPaymentSection: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      benefits: [
        { text: "Precios bajos" },
        { text: "Envío asegurado" },
        { text: "Garantía directa" },
        { text: "Envío personalizado" },
        { text: "100% Productos nuevos" },
        { text: "Pago seguro con tarjetas" },
      ],
    };
  },

  computed: {
    paymentMethods(): Array<PaypmentMethodHome & { mobile: boolean }> {
      return [
        {
          id: 1,
          name: "visa",
          image: "/images/payments/banner/visa.svg",
          link: "url",
          show: this.showVisa,
          mobile: true,
        },
        {
          id: 2,
          name: "master",
          image: "/images/payments/banner/mastercard.svg",
          link: "url",
          show: this.showMaster,
          mobile: true,
        },
        {
          id: 3,
          name: "paypal",
          image: "/images/payments/banner/paypal.svg",
          link: "url",
          show: this.showPaypal,
          mobile: true,
        },
        {
          id: 4,
          name: "rappi",
          image: "/images/payments/banner/rappi.svg",
          link: "url",
          show: this.showRappi,
          mobile: false,
        },
        {
          id: 5,
          name: "walmart",
          image: "/images/payments/banner/walmart.svg",
          link: "url",
          show: this.showWalmart,
          mobile: true,
        },
        {
          id: 6,
          name: "benavides",
          image: "/images/payments/banner/benavides.svg",
          link: "url",
          show: this.showBenavides,
          mobile: false,
        },
        {
          id: 7,
          name: "sams",
          image: "/images/payments/banner/sams.svg",
          link: "url",
          show: this.showSams,
          mobile: false,
        },
        {
          id: 8,
          name: "seven",
          image: "/images/payments/banner/711.svg",
          link: "url",
          show: this.showSeven,
          mobile: false,
        },
        {
          id: 10,
          name: "visa",
          image: "/images/payments/banner/visa.svg",
          link: "url",
          show: this.showVisa2,
          mobile: false,
        },
        {
          id: 11,
          name: "master",
          image: "/images/payments/banner/mastercard.svg",
          link: "url",
          show: this.showMaster2,
          mobile: false,
        },
        {
          id: 12,
          name: "paypal",
          image: "/images/payments/banner/paypal.svg",
          link: "url",
          show: this.showPaypal2,
          mobile: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/product";
.image-payment {
  object-fit: contain;
}

.height-col {
  height: 24px;

  @media (min-width: 576px) {
    height: 35px;
  }

  @media (min-width: 768px) {
    height: 48px;
  }

  @media (min-width: 992px) {
    height: 100%;
  }
}

.payment-method-desktop-only {
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
}
</style>
